import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiArrowRight, FiStar } from "react-icons/fi";
import useCreateRating from "api/RatingResource/useCreateRating";
import useAuthStore from "store/authStore";
import { toLoginUrl } from "utils/intendedUrl";

export default function BookReaderRating({ book }) {
	const loggedIn = useAuthStore((state) => state.loggedIn);
	const location = useLocation();
	const mutation = useCreateRating(book.id);
	const [value, setValue] = useState(Number(book.user_rating) || 0);
	const [notice, setNotice] = useState("");
	const [pending, setPending] = useState(false);
	const guard = useRef(false);
	useEffect(() => { setValue(Number(book.user_rating) || 0); }, [book.user_rating]);
	const rate = async (score) => {
		if (!loggedIn || guard.current) return;
		guard.current = true;
		setPending(true);
		const previous = value;
		setValue(score); setNotice("");
		try { await mutation.mutateAsync({ book_id: book.id, score }); setNotice("Thanks for sharing your rating."); }
		catch { setValue(previous); setNotice("Your rating couldn’t be saved. Please try again."); }
		finally { guard.current = false; setPending(false); }
	};
	return <section className="book-detail-reader-rating" id="reader-rating" aria-labelledby="reader-rating-heading">
		<div><p className="book-detail-eyebrow">A LITTLE READER PERSPECTIVE</p><h2 id="reader-rating-heading">Read it? Rate it.</h2><p>Your rating can help another reader find their next book.</p></div>
		{loggedIn ? <div><fieldset disabled={pending || mutation.isLoading} className="book-detail-rating-input"><legend className="sr-only">Your rating</legend>{[1, 2, 3, 4, 5].map((score) => <label key={score}><input type="radio" name={`rating-${book.id}`} value={score} checked={value === score} onChange={() => rate(score)} aria-label={`${score} ${score === 1 ? "star" : "stars"}`} /><FiStar aria-hidden="true" className={score <= value ? "is-filled" : ""} /></label>)}</fieldset><p role="status" aria-live="polite">{pending ? "Saving your rating…" : notice || (value ? `Your rating: ${value} out of 5` : "Choose a star to share your rating.")}</p></div> : <Link className="book-detail-text-link" to={toLoginUrl(location)}>Sign in to rate this book<FiArrowRight aria-hidden="true" /></Link>}
	</section>;
}
